import React, { FunctionComponent } from 'react'
import { Route, Routes } from 'react-router'

import { useIsMtaAllowed } from '../../../../hooks/adjustments/policy/renewal'
import { AppPath } from '../../../AppPath'
import { BillingManager } from '../billing'
import { CancellationRouter } from '../cancellation'
import { CancellationConfirmationPage } from '../cancellation/CancellationConfirmationPage'
import { PolicyTabs } from '../configuration'
import { AddOnRouter } from '../covers'
import { ExcessRouter } from '../excess'
import { PolicyManagementRouter } from '../management'
import { PolicyPath } from '../PolicyPath'
import { UploadRouter } from '../upload'

export const PolicyActiveRoutes: FunctionComponent = () => {
  const isMtaAllowed = useIsMtaAllowed()

  return (
    <BillingManager>
      <Routes>
        <Route
          path={PolicyPath.CANCEL + AppPath.WILDCARD}
          element={<CancellationRouter />}
        />

        <Route
          path={PolicyPath.CANCEL_CONFIRMATION}
          element={<CancellationConfirmationPage />}
        />

        <Route path={PolicyPath.UPLOADS + AppPath.WILDCARD} element={<UploadRouter />} />

        {isMtaAllowed && (
          <Route
            path={PolicyPath.MANAGEMENT + AppPath.WILDCARD}
            element={<PolicyManagementRouter />}
          />
        )}

        {isMtaAllowed && (
          <Route path={PolicyPath.EXCESS + AppPath.WILDCARD} element={<ExcessRouter />} />
        )}

        {isMtaAllowed && (
          <Route path={PolicyPath.ADD_ONS + AppPath.WILDCARD} element={<AddOnRouter />} />
        )}

        <Route path='*' element={<PolicyTabs />} />
      </Routes>
    </BillingManager>
  )
}
